/**
 * @generated SignedSource<<f6ac0d7cd84ae20034634da0f6e91864>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "lastChatAtFrom"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "lastChatAtTo"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "liveChat"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tags"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wChannelIds"
},
v6 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 1
    },
    {
      "kind": "Variable",
      "name": "lastChatAtFrom",
      "variableName": "lastChatAtFrom"
    },
    {
      "kind": "Variable",
      "name": "lastChatAtTo",
      "variableName": "lastChatAtTo"
    },
    {
      "kind": "Variable",
      "name": "liveChat",
      "variableName": "liveChat"
    },
    {
      "kind": "Variable",
      "name": "search",
      "variableName": "search"
    },
    {
      "kind": "Variable",
      "name": "tags",
      "variableName": "tags"
    },
    {
      "kind": "Variable",
      "name": "wChannelIds",
      "variableName": "wChannelIds"
    }
  ],
  "concreteType": "ThreadConnection",
  "kind": "LinkedField",
  "name": "threads",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PageInfo",
      "kind": "LinkedField",
      "name": "pageInfo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "GlobalThreadsSelectAllCountQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserScope",
        "kind": "LinkedField",
        "name": "userViewer",
        "plural": false,
        "selections": [
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "GlobalThreadsSelectAllCountQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserScope",
        "kind": "LinkedField",
        "name": "userViewer",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1000c0ed4e488d376e5241a690f7c316",
    "id": null,
    "metadata": {},
    "name": "GlobalThreadsSelectAllCountQuery",
    "operationKind": "query",
    "text": "query GlobalThreadsSelectAllCountQuery(\n  $search: String\n  $wChannelIds: [ID]\n  $liveChat: Boolean\n  $lastChatAtFrom: Long\n  $lastChatAtTo: Long\n  $tags: [String]\n) {\n  userViewer {\n    threads(search: $search, wChannelIds: $wChannelIds, liveChat: $liveChat, lastChatAtFrom: $lastChatAtFrom, lastChatAtTo: $lastChatAtTo, tags: $tags, first: 1) {\n      pageInfo {\n        totalCount\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

node.hash = "b250a82e66ba2abff6c369b6224ad153";

module.exports = node;
